import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { toast } from 'sonner';

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);
  
  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    
    const processAuth = async () => {
      try {
        // Extract session_id from URL fragment
        const fragment = location.hash.substring(1);
        const params = new URLSearchParams(fragment);
        const sessionId = params.get('session_id');
        
        if (!sessionId) {
          toast.error('Error de autenticación');
          navigate('/login', { replace: true });
          return;
        }
        
        // Exchange session_id for session_token
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/session`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({ session_id: sessionId })
        });
        
        if (!response.ok) {
          throw new Error('Failed to authenticate');
        }
        
        const data = await response.json();
        
        // Navigate to dashboard with user data
        navigate('/dashboard', { 
          replace: true,
          state: { user: data.user }
        });
        
        toast.success(`¡Bienvenido, ${data.user.name}!`);
      } catch (error) {
        console.error('Auth error:', error);
        toast.error('Error al iniciar sesión');
        navigate('/login', { replace: true });
      }
    };
    
    processAuth();
  }, [navigate, location.hash]);
  
  return (
    <div className="flex items-center justify-center min-h-screen bg-black">
      <div className="text-center space-y-4">
        <div className="text-white text-2xl font-heading uppercase tracking-wider animate-pulse">
          AUTENTICANDO...
        </div>
        <div className="w-12 h-12 border-4 border-primary border-t-transparent rounded-full animate-spin mx-auto" />
      </div>
    </div>
  );
};

export default AuthCallback;
